import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
	Modal,
	Button,
	FileImport,
	ProgressIndicator
} from "rhombus-react";

import { closeModal } from "reducers/Modal";
import { importCreativeLabels } from "reducers/Creatives";
import { importVersionLabels } from "reducers/CreativeVersions";
import { MODAL_TYPES } from "utils/constants";

import "./ImportTaxonomyModal.css";

export default function ImportTaxonomyModal({ creativeId }){
	const dispatch = useDispatch();
	const [formData, setFormData] = useState(null);
	const [isImporting, setIsImporting] = useState(false);
	const modal = useSelector(state => state.modal);
	const libraryId = useSelector(state => state.libraryProperties?.id);

	const isOpen = modal.isOpen && modal.modalType === MODAL_TYPES.IMPORT_TAXONOMY;

	useEffect(()=> {
		setIsImporting(false);
		setFormData(null);
	}, [isOpen]);

	if(!isOpen){
		return null;
	}

	let title = "Import Creative Labels";
	let isFileSelected = formData !== null;

	function onClose(){
		dispatch(closeModal());
	}

	function handleImport(){
		if(formData){
			setIsImporting(true);
			let uploadAction = () => importCreativeLabels(formData, libraryId);

			if(creativeId) {
				uploadAction = () => importVersionLabels(formData, libraryId, creativeId);
			}

			dispatch(uploadAction()).then((resp)=> {
				setIsImporting(false);
				if(resp?.success){
					dispatch(closeModal());
				}
			});
		}
	}

	function handleFileSelectionChange(changeList){
		if(changeList?.length){
			let [importedData] = changeList
				, { formData } = importedData
				, importFile = formData.get("file")
				, newFormData = new FormData()
			;
			newFormData.append("file", importFile);
			setFormData(newFormData);
		}
	}

	const fileImportProps = {
		label: "Select File",
		required: true,
		inputPlaceholder: "Click browse to select spreadsheet",
		useField: false,
		multipleFiles: false,
		onChange: handleFileSelectionChange,
		disabled: isImporting,
		accept: ".xlsx",
	};

	function renderContent(){
		return (
			<div className="import-taxonomy">
				<ProgressIndicator isLoading={isImporting} />
				<FileImport {...fileImportProps} />
			</div>
		);
	}

	function renderFooter(){
		return (
			<>
				<Button
					key="cancel"
					theme = "default"
					onClick = {onClose}
				>
					Cancel
				</Button>
				<Button
					key="import"
					theme="green"
					onClick={handleImport}
					disabled={!isFileSelected || isImporting}
				>
					Import
				</Button>
			</>
		);
	}

	let bladeProps = {
		verticallyCenter: true,
	};

	const importModalProps = {
		title,
		type: "modal",
		className: "import-taxonomy-modal",
		xClose: true,
		allowFullScreen: false,
		bladeProps,
		renderContent,
		renderFooter,
		onClose,
	};

	return <Modal {...importModalProps} />;
}

ImportTaxonomyModal.displayName = "ImportTaxonomyModal";
